<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="编辑"
      @ok="handleSubmit"
    >
      <a-form
        class="simiot-compact-form"
        :form="form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 15 }"
        @submit="handleSubmit"
      >

        <a-form-item label="通用套餐名称">
          <a-input
            v-decorator="['name', {
              normalize: this.$lodash.trim,
              rules: [
                { required: true, message: '请输入通用套餐名称' },
                { max: 100, message: '最多100个字符' },
              ]
            }]"
          />
        </a-form-item>

        <a-form-item label="运营商">
          <a-select
            v-decorator="['carrier_type', {
              rules: [{ required: true, message: '请选择运营商' }]
            }]"
            allow-clear
            placeholder="请选择"
            @change="handleCarrierTypeChange"
          >
            <a-select-option
              v-for="option in carrierTypeOptions"
              :key="option.value"
              :value="option.value"
            >
              {{ option.label }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="流量场景">
          <a-select
            v-decorator="['traffic_scene_id', {
              rules: [{ required: true, message: '请选择流量场景' }]
            }]"
            allow-clear
            show-search
            option-filter-prop="children"
            :disabled="!selectedCarrierType"
            :loading="loadingTrafficSceneOptions"
          >
            <a-select-option
              v-for="option in trafficSceneOptions"
              :key="option.id"
              :value="option.id"
            >
              {{ option.name }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          label="标签"
          class="simiot-display-item"
        >
          {{ data.tags_display }}
        </a-form-item>

        <a-form-item
          label="共享属性"
          class="simiot-display-item"
        >
          {{ data.traffic_share_property_display }}
        </a-form-item>

        <a-form-item
          label="服务周期"
          class="simiot-display-item"
        >
          {{ data.service_cycle_display }}
        </a-form-item>

        <a-form-item
          label="套餐容量"
          class="simiot-display-item"
          v-if="isShowCapacityFields"
        >
          {{ data.package_capacity_display }}
        </a-form-item>

        <a-form-item label="语音" class="simiot-display-item">
          {{ data.voice_capacity_display }}
        </a-form-item>

        <a-form-item
          label="卡片材质"
          class="simiot-display-item"
        >
          {{ data.card_type }}
        </a-form-item>

        <a-form-item
          label="卡片尺寸"
          class="simiot-display-item"
        >
          {{ data.card_shape_name }}
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { findBaseCarrierProductForm, updateBaseCarrierProduct } from '@/api/base_carrier_product'
import { findCarrierTypeOptions } from '@/api/common_options'
import { findTrafficSceneOptions } from '@/api/traffic_scene'

export default {
  name: 'EditBaseCarrierProduct',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'base_carrier_product' }),
      submitting: false,
      isShowCapacityFields: true,
      trafficSceneOptions: [],
      selectedCarrierType: undefined,
      loadingTrafficSceneOptions: false,
      carrierTypeOptions: findCarrierTypeOptions(),
      data: {}
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.fetchFormData()
  },
  methods: {
    handleCarrierTypeChange(carrierType) {
      this.selectedCarrierType = carrierType
      this.form.setFieldsValue({
        traffic_scene_id: undefined
      })
      this.fetchTrafficSceneOptions(carrierType)
    },

    ensureCurrentTrafficSceneOption() {
      const trafficSceneId = this.data.traffic_scene_id
      if (!trafficSceneId) {
        return
      }
      if (this.trafficSceneOptions.some(o => o.id === trafficSceneId)) {
        return
      }
      this.trafficSceneOptions = [
        {
          id: trafficSceneId,
          name: this.data.traffic_scene || String(trafficSceneId),
          carrier_type: this.data.carrier_type
        },
        ...this.trafficSceneOptions
      ]
    },

    fetchTrafficSceneOptions(carrierType) {
      if (!carrierType) {
        this.trafficSceneOptions = []
        return Promise.resolve()
      }

      this.loadingTrafficSceneOptions = true
      return findTrafficSceneOptions({ carrier_type: carrierType }).then(res => {
        if (res.code === 0) {
          this.trafficSceneOptions = res.data || []
          this.ensureCurrentTrafficSceneOption()
        }
        this.loadingTrafficSceneOptions = false
      })
    },

    fetchFormData() {
      findBaseCarrierProductForm(this.id).then((res) => {
        this.data = res.data
        this.isShowCapacityFields = res.data.traffic_share_property !== 'backward'
        this.selectedCarrierType = res.data.carrier_type || undefined
        this.fetchTrafficSceneOptions(this.selectedCarrierType).then(() => {
          this.form.setFieldsValue({
            name: res.data.name,
            carrier_type: res.data.carrier_type || undefined,
            traffic_scene_id: res.data.traffic_scene_id || undefined
          })
        })
      })
    },
    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }

      this.form.validateFields((err, values) => {
        if (!err) {
          this.submitting = true
          updateBaseCarrierProduct(this.id, values).then((res) => {
            if (res.code === 0) {
              // 关闭模态框
              this.isShow = false
              // 告知父组件已完成
              this.$emit('completed')
            }
            this.submitting = false
          })
        }
      })
    }
  }
}
</script>
